import React from "react";
import { FaSearch, FaSync } from "react-icons/fa";
import { JobCard } from "./JobCard";
import WhatsAppChannelHorizontalCard from "../extras/WhatsappHorizontal";
import { useAuth } from "../Authentication/AuthContext";
import { useVisitor } from "../extras/VisitorContext";

export default function JobList({
  jobs,
  currentPage: _currentPage,
  setCurrentPage: _setCurrentPage,
  isLastPage: _isLastPage,
}) {
  const { user } = useAuth();
  const { visitorId } = useVisitor();

  if (!jobs || jobs.length === 0) {
    return <EmptyJobList />;
  }

  return (
    <div className="space-y-8">
      {/* Job Cards */}
      {jobs.map((job, i) => (
        <React.Fragment key={job.id || job._id}>
          <JobCard job={job} user={user ? user : { userId: visitorId }} />
          {i % 3 === 2 ? <WhatsAppChannelHorizontalCard /> : null}
        </React.Fragment>
      ))}
    </div>
  );
}

export function EmptyJobList() {
  return (
    <div className="space-y-8">
      {/* Empty State */}
      <div className="ca-card p-10 sm:p-16 text-center">
        <div className="w-14 h-14 bg-gray-50 border border-gray-200 rounded-full flex items-center justify-center mx-auto mb-6">
          <FaSearch className="text-2xl text-gray-400" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-3">
          No results
        </h3>
        <p className="text-gray-700 max-w-md mx-auto mb-6">
          We couldn’t find any jobs matching your criteria. Try adjusting your
          filters.
        </p>
        <button className="ca-btn-primary px-5 py-2">
          <FaSync className="mr-2" /> Clear All Filters
        </button>
      </div>
    </div>
  );
}
